export const quotationsState: aboTheme.IState = {
    parent: "app",
    name: "quotations",
    url: "/quotations",
    redirectTo: "quotations.proforma",
    component: "quotationsComponent",
    data: {
        permissions: {
            only: ['FINANCE'],
            redirectTo: 'schedule'
        }
    }
};

export const quotationProformaState: aboTheme.IState = {

    name: "quotations.proforma",
    url: "/proforma",
    params: {
        proformaInvoicesOnly: true
    },
    views: {
        "main": 'quotationsDashboardComponent'
    }
};

export const quotationCootjeState: aboTheme.IState = {

    name: "quotations.cootje",
    url: "/cootje",
    params: {
        proformaInvoicesOnly: true
    },
    views: {
        "main": 'quotationsCootjeComponent'
    }
};

export const quotationDashboardState: aboTheme.IState = {

    name: "quotations.dashboard",
    url: "/dashboard",
    params: {
        proformaInvoicesOnly: false
    },
    views: {
        "main": 'quotationsDashboardComponent'
    }
};


// WEBPACK FOOTER //
// ./src/app/modules/quotations/quotations.states.ts